import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, message } from 'antd';
import { batchAlarmOperation } from '@/service/jtAlarmConfig';
import { Alarm808PushRecord } from '@/service/jtAlarmConfig/define';
import { displayJtDeviceAlarmV2 } from '@/utils/jtDeviceAlarm';

const { TextArea } = Input;

interface BatchOperationModalProps {
  visible: boolean;
  selectedRecords: Alarm808PushRecord[];
  onClose: () => void;
  onSuccess: () => void;
}

export const BatchOperationModal: React.FC<BatchOperationModalProps> = ({
  visible,
  selectedRecords,
  onClose,
  onSuccess
}) => {
  const [form] = Form.useForm();
  const [submitLoading, setSubmitLoading] = useState(false);

  // 当弹窗打开时，重置表单
  useEffect(() => {
    if (visible) {
      form.resetFields();
    }
  }, [visible, form]);

  // 提交批量处理
  const handleSubmit = async () => {
    try {
      setSubmitLoading(true);
      const values = await form.validateFields();
      const res = await batchAlarmOperation({
        ids: selectedRecords.map((record) => record.id),
        remark: values.remark
      } as any);
      if (res?.data?.success) {
        message.success('批量处理成功');
        onSuccess();
        onClose();
      } else {
        message.error(res?.data?.msg || '批量处理失败');
      }
    } catch (error) {
      console.error('批量处理失败:', error);
      message.error('批量处理失败，请稍后重试');
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <Modal
      title="批量处理"
      open={visible}
      onOk={handleSubmit}
      onCancel={onClose}
      confirmLoading={submitLoading}
      destroyOnClose
      width={600}
    >
      <div style={{ marginBottom: 16 }}>
        <div style={{ marginBottom: 8, fontWeight: 'bold' }}>
          选中的记录（共{selectedRecords.length}条）：
        </div>
        <div
          style={{
            maxHeight: 200,
            overflowY: 'auto',
            border: '1px solid #d9d9d9',
            borderRadius: 4,
            padding: 8
          }}
        >
          {selectedRecords.map((record) => (
            <div
              key={record.id}
              style={{
                padding: '8px 0',
                borderBottom: '1px solid #f0f0f0'
              }}
            >
              <div>ID: {record.id}</div>
              <div>车牌号: {record.plateNumber}</div>
              <div>
                报警类型:{' '}
                {displayJtDeviceAlarmV2({
                  alarmType: Number(record.alarmType ?? 0),
                  warningType: Number(record.warningType ?? 0)
                })}
              </div>
              <div>上报时间: {record.reportTime}</div>
            </div>
          ))}
        </div>
      </div>
      <Form form={form} layout="vertical">
        <Form.Item label="处理意见" name="remark">
          <TextArea rows={4} placeholder="请输入处理意见" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default BatchOperationModal;
